import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const EyeIcon = ({ size = 'sm', color = 'currentColor', dataTrackTag = pascalToSnake('EyeIcon') }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.107 8.5a2.107 2.107 0 1 0-4.213 0 2.107 2.107 0 0 0 4.213 0Z"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke={getStrokeColor(color)}
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 3.584c2.936 0 5.452 2.818 6.5 4.187a1.19 1.19 0 0 1 0 1.457c-1.048 1.369-3.564 4.187-6.5 4.187s-5.452-2.818-6.5-4.187a1.19 1.19 0 0 1 0-1.457C2.548 6.402 5.064 3.584 8 3.584Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
EyeIcon.id = 'EyeIcon';
EyeIcon.displayName = 'EyeIcon';
export default EyeIcon;
